"use strict";
/**
 * This file was auto generated, please do not edit it directly.
 **/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmailSample = void 0;

var EmailSample =
/** @class */
function () {
  function EmailSample(restClient) {
    this.restClient = restClient;
  } // Queries

  /**
   * @param string - emailDesignId
   * @return Promise|Observable|any
   */


  EmailSample.prototype.GetEmailThumbnailUrl = function (emailDesignId) {
    return this.restClient.get('EmailSample/UseCase/GetEmailThumbnailUrl', {
      emailDesignId: emailDesignId
    });
  };
  /**
   * @param string - emailDesignId
   * @param string[]? - withData EmailPreview|EmailSpamResult
   * @return Promise|Observable|any
   */


  EmailSample.prototype.GetLatestEmailSampleForDesign = function (emailDesignId, withData) {
    if (withData === void 0) {
      withData = null;
    }

    return this.restClient.get('EmailSample/UseCase/GetLatestEmailSampleForDesign', {
      emailDesignId: emailDesignId,
      withData: withData
    });
  }; // Commands

  /**
   * @param string - previewUrl
   * @param string - previewClient
   * @param string - operatingSystem
   * @param string - displayName
   * @param string - thumbnailUrl
   * @param string - emailSampleId
   * @param string? - emailPreviewId
   * @return Promise|Observable|any
   */


  EmailSample.prototype.CreateEmailPreview = function (previewUrl, previewClient, operatingSystem, displayName, thumbnailUrl, emailSampleId, emailPreviewId) {
    if (emailPreviewId === void 0) {
      emailPreviewId = null;
    }

    return this.restClient.post('EmailSample/UseCase/CreateEmailPreview', {
      previewUrl: previewUrl,
      previewClient: previewClient,
      operatingSystem: operatingSystem,
      displayName: displayName,
      thumbnailUrl: thumbnailUrl,
      emailSampleId: emailSampleId,
      emailPreviewId: emailPreviewId
    });
  };
  /**
   * @param string - htmlContent
   * @param string - emailDesignId
   * @param boolean - overrideMinimumInterval true|false
   * @param string? - emailSampleId
   * @return Promise|Observable|any
   */


  EmailSample.prototype.CreateEmailSample = function (htmlContent, emailDesignId, overrideMinimumInterval, emailSampleId) {
    if (emailSampleId === void 0) {
      emailSampleId = null;
    }

    return this.restClient.post('EmailSample/UseCase/CreateEmailSample', {
      htmlContent: htmlContent,
      emailDesignId: emailDesignId,
      overrideMinimumInterval: overrideMinimumInterval,
      emailSampleId: emailSampleId
    });
  };
  /**
   * @param string - spamClient
   * @param string - testType
   * @param string - testDetails
   * @param number - isSpam
   * @param string - emailSampleId
   * @param string? - emailSpamResultId
   * @return Promise|Observable|any
   */


  EmailSample.prototype.CreateEmailSpamResult = function (spamClient, testType, testDetails, isSpam, emailSampleId, emailSpamResultId) {
    if (emailSpamResultId === void 0) {
      emailSpamResultId = null;
    }

    return this.restClient.post('EmailSample/UseCase/CreateEmailSpamResult', {
      spamClient: spamClient,
      testType: testType,
      testDetails: testDetails,
      isSpam: isSpam,
      emailSampleId: emailSampleId,
      emailSpamResultId: emailSpamResultId
    });
  };

  return EmailSample;
}();

exports.EmailSample = EmailSample;